import { useEffect, useState } from "react";
import { JobSuitcaseIcon } from "@tabbio/public-renderers";

type JobLogoProps = {
  uri?: string | null;
  size?: number;
  imageSize?: number;
  radius?: number;
};

export function JobLogo({
  uri,
  size = 48,
  imageSize = 34,
  radius = 10,
}: JobLogoProps) {
  const [imageFailed, setImageFailed] = useState(false);
  const normalizedUri = uri?.trim() || null;
  const showImage = Boolean(normalizedUri) && !imageFailed;

  useEffect(() => {
    setImageFailed(false);
  }, [normalizedUri]);

  return (
    <div
      aria-hidden
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        border: "1px solid var(--tabbio-border-subtle, var(--input-border))",
        background: "var(--tabbio-surface, var(--surface-secondary, var(--surface)))",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {showImage ? (
        <img
          src={normalizedUri as string}
          alt=""
          onError={() => setImageFailed(true)}
          style={{
            width: imageSize,
            height: imageSize,
            objectFit: "contain",
            display: "block",
          }}
        />
      ) : (
        <JobSuitcaseIcon
          size={Math.round(size * 0.48)}
          style={{ color: "var(--text-tertiary)" }}
        />
      )}
    </div>
  );
}
